import Variant from "../../../../Models/Variant";
import Mediator from "../../../../Utilities/Mediator";
import OrderHandler from "../../OrderHandler";
import Service from "../../../../Models/Service";

export default class MeasurementModal {
	service: Service;
	measureModalDiv: HTMLDivElement;
	form: HTMLFormElement;
	needleInput: HTMLInputElement;
	longerInput: HTMLInputElement;
	shorterInput: HTMLInputElement;
	saveBtn: HTMLButtonElement;
	oldValue: string;
	serviceIndex: number;
	selectedVariant: Variant;
	errorMsgP: HTMLParagraphElement;

	constructor(service: Service, variantObject: Variant) {
		this.service = service; //service with all variants
		this.selectedVariant = variantObject;
		this.measureModalDiv = document.querySelector('#measure-modal');
		this.measureModalDiv.style.display = "flex";
		this.form = this.measureModalDiv.querySelector("form");
		this.longerInput = this.form.elements[0] as HTMLInputElement;
		this.shorterInput = this.form.elements[1] as HTMLInputElement;
		this.needleInput = this.form.elements[2] as HTMLInputElement;
		this.saveBtn = document.querySelector('#cancel + button');
		this.errorMsgP = this.form.querySelector('p');
		this.serviceIndex = OrderHandler.selectedItem.services.findIndex(s => s.id === service.id);

		this.addMesaurementButtonsClickListeners()
		this.addMeasurementInputsEventsListeners();
		this.checkServiceMeasurements();
		this.disableMeasurementModalInputs();
	}

	private addMesaurementButtonsClickListeners() {
		const img: HTMLImageElement = this.measureModalDiv.querySelector('img[alt="close icon"]');
		img.onclick = () => {
			this.removeMeasurement();
		}

		const btnCancel = document.getElementById("cancel");
		btnCancel.onclick = () => {
			this.removeMeasurement();
		}

		this.saveBtn.onclick = () => {
			this.selectedVariant.byNeedle = this.needleInput.value ? true : false;
			this.selectedVariant.cmDown = parseFloat(this.longerInput.value);
			this.selectedVariant.cmUp= parseFloat(this.shorterInput.value);
			OrderHandler.selectedItem.services[this.serviceIndex].variants.splice(0, 1, this.selectedVariant);
			OrderHandler.addSelectedItemToShoppingCart();
			Mediator.emit("serviceCostChanged", this.service.id, this.selectedVariant.cost);
			this.measureModalDiv.style.display = "none";
			const backToStep1: boolean = OrderHandler.selectedItem.hasSimpleOrderFlow;
			Mediator.emit("variantIsSelected", this.service.variants.length > 1, backToStep1);
		}
	}

	private addMeasurementInputsEventsListeners() {
		this.needleInput.onchange = () => {
			this.needleInput.value = this.needleInput.checked ? "true" : "";
			this.disableMeasurementModalInputs();
		}

		this.longerInput.onkeydown = () => {
			this.oldValue = this.longerInput.value;
		}

		this.longerInput.oninput = () => {
			this.validateNumber(this.longerInput);
			this.disableMeasurementModalInputs();
		}

		const imgIncreaseLonger: HTMLImageElement =
			this.form.querySelector('input[name="cmdown"] + div.input-number img[alt="increase icon"]');
		imgIncreaseLonger.onclick = () => {
			this.changeValue(this.longerInput, true);
			this.disableMeasurementModalInputs();
		}

		const imgDecreaseLonger: HTMLImageElement =
			this.form.querySelector('input[name="cmdown"] + div.input-number img[alt="decrease icon"]');
		imgDecreaseLonger.onclick = () => {
			this.changeValue(this.longerInput, false);
			this.disableMeasurementModalInputs();
		}

		this.shorterInput.onkeydown = () => {
			this.oldValue = this.shorterInput.value;
		}

		this.shorterInput.oninput = () => {
			this.validateNumber(this.shorterInput);
			this.disableMeasurementModalInputs();
		}

		const imgIncreaseShorter: HTMLImageElement =
			this.form.querySelector('input[name="cmup"] + div.input-number img[alt="increase icon"]');
		imgIncreaseShorter.onclick = () => {
			this.changeValue(this.shorterInput, true);
			this.disableMeasurementModalInputs();
		}

		const imgDecreaseShorter: HTMLImageElement =
			this.form.querySelector('input[name="cmup"] + div.input-number img[alt="decrease icon"]');
		imgDecreaseShorter.onclick = () => {
			this.changeValue(this.shorterInput, false);
			this.disableMeasurementModalInputs();
		}
	}

	private checkServiceMeasurements() {
		this.form.reset();
		if (OrderHandler.selectedItem.services[this.serviceIndex].variants.find(v => v)) {
			if (this.selectedVariant.cmDown) {
				this.longerInput.value = this.selectedVariant.cmDown.toString();
			}
			if (this.selectedVariant.cmUp) {
				this.shorterInput.value = this.selectedVariant.cmUp.toString();
			}
			if (this.selectedVariant.byNeedle) {
				this.needleInput.checked = true;
			}
		} else {
			this.needleInput.value = "";
		}
	}

	private disableMeasurementModalInputs() {
		const wrapperContainer: HTMLDivElement = this.form.querySelector("div");
		const inputWrappers: NodeListOf<HTMLDivElement> = this.form.querySelectorAll(".bg-transparent");

		let valuesCount: number = 0;
		let input: HTMLInputElement;
		let inputWrapper: HTMLDivElement;
		for (let j = 0; j < this.form.elements.length; j++) {
			input = this.form.elements[j] as HTMLInputElement;
			inputWrapper = wrapperContainer.children[j] as HTMLDivElement;
			if (input.value) {
				valuesCount++;
				input.disabled = false;
				inputWrapper.style.opacity = "1";
				inputWrappers[j].style.display = "none";
			} else {
				input.disabled = true;
				inputWrapper.style.opacity = "0.5";
				inputWrappers[j].style.display = "inline-block";
			}
		}
		if (valuesCount === 1) {
			this.saveBtn.disabled = false;
			this.saveBtn.style.opacity = "1";
		} else {
			this.saveBtn.disabled = true;
			this.saveBtn.style.opacity = "0.5";
			if (valuesCount === 0) {
				for (let j = 0; j < this.form.elements.length; j++) {
					input = this.form.elements[j] as HTMLInputElement;
					inputWrapper = wrapperContainer.children[j] as HTMLDivElement;
					input.disabled = false;
					inputWrapper.style.opacity = "1";
					inputWrappers.forEach(d => d.style.display = "none");
				}
			}
		}
	}

	private removeMeasurement() {
		this.measureModalDiv.style.display = "none";
		this.form.reset();
		this.needleInput.value = "";
		Mediator.emit("serviceCostChanged", this.service.id, -1);
		Mediator.emit("variantRemoved", this.selectedVariant.id);
		OrderHandler.removeVariants(OrderHandler.selectedItem.itemId, this.service.id);
	}

	private changeValue(input: HTMLInputElement, addSign: boolean) {
		if (input.value) {
			let cmValue: number = parseFloat(input.value);
			if (addSign) {
				if (cmValue >= 0.5 && cmValue <= 99.9) {
					cmValue += 0.5;
				}
			} else {
				if (cmValue >= 1 && cmValue <= 99.9) {
					cmValue -= 0.5;
				}
			}
			input.value = cmValue.toFixed(1).toString();
		} else {
			input.value = "1";
		}
	}

	private validateNumber(input: HTMLInputElement) {
		const regex = /^\d{1,2}([.][5-9]\d?)?$/;
		if (input.value && !regex.test(input.value)) {
			input.value = this.oldValue;
			this.errorMsgP.style.opacity = "1";
		} else {
			this.errorMsgP.style.opacity = "0";
		}
	}
}
